export default {
      id: "caret-left-usage",
      viewBox: "0 0 5 8",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#caret-left",
      toString: function () {
        return this.url;
      }
    }